import { createApiClient } from '@inbody/data';
import { useAuthInterceptors } from '@inbody/keycloak';

const CLIENT_ID = 'd365-data-center';

// BYOD 원장 조회(매출송장/배송오더 등)는 기간이 넓으면 30초를 넘기므로 공용 기본값을 올린다.
// ponytail: 프론트 타임아웃만 늘린 것. 서버 504 가 뜨면 백엔드 페이징이 필요하다.
const TIMEOUT = 120000; // 2분

/**
 * d365-data-center 인증 API 클라이언트.
 * baseUrl 은 `VITE_API_URL`(origin) 사용. 엔드포인트는 leading slash 없이 전달.
 */
export const useApiClient = () => {
  const baseUrl = import.meta.env.VITE_API_URL;
  const authInterceptors = useAuthInterceptors({ clientId: CLIENT_ID });

  return createApiClient(baseUrl, {
    hooks: authInterceptors,
    timeout: TIMEOUT,
  });
};
